
/**
 * Adres aplikacji BO
 */
export const BACKOFFICE_APPLICATION = process.env.REACT_APP_FLOW_BACKOFFICE;

/**
 * Adres serwera proxy
 */
export const PROXY_SERVER = process.env.REACT_APP_FLOW_PROXY_SERVER;

/**
 * Interwal w milisekundach co jaki odpytujemy się o połączenia, kiedy tab jest widczony z połączeniami
 */
export const CONNECTION_INTERVAL_TIME_IN_MILLIS = 1000;